// utils/permissions.js
export const hasPermission = (userPermissions, required) => {
  if (!required) return true; // if no requirement, always allow
  if (!userPermissions || !Array.isArray(userPermissions)) return false;

  const userPermissionIds = userPermissions.map((perm) => perm.id);

  // If required is a single string UUID
  if (typeof required === "string") {
    return userPermissionIds.includes(required);
  }

  // If required is an array of UUIDs
  if (Array.isArray(required)) {
    return required.some((permId) => userPermissionIds.includes(permId));
  }

  return false;
};
